import { type SelectItem } from "@mantine/core";

import { type LogbookSelectItem, type PermSelectItem } from "./UserForm.types";

export const mapUserForm = (data: any) => {
  const initialValues = {
    type: (data?.data?.user?.usertype || "") as string,
    role: (data?.data?.user?.roletype || "") as string,
    fname: (data?.data?.user?.firstname || "") as string,
    sname: (data?.data?.user?.surname || "") as string,
    phoneno: (data?.data?.user?.phoneno || "") as string,
    mobile: (data?.data?.user?.mobile || "") as string,
    email: (data?.data?.user?.email || "") as string,
    personalEmail: (data?.data?.user?.personalEmail || "") as string,
    active: (data?.data?.user?.active ?? true) as boolean,
    deleted: (data?.data?.user?.deleted ?? false) as boolean,
    medofficer: (data?.data?.user?.medofficer ?? false) as boolean,
    rotation: (data?.data?.user?.rotation ?? false) as boolean,
    logbooks: (data?.data?.user?.logbooks || []) as string[],
    perms: (data?.data?.user?.perms || []) as string[],
    extref: (data?.data?.user?.extref || "") as string,
    dischargeID: (data?.data?.user?.dischargeID || "") as string,
    seabodyID: (data?.data?.user?.seabodyID || "") as string,
    coc: (data?.data?.user?.coc || []) as any[],
  };
  const adminPerms: PermSelectItem[] = [];
  const userPerms: PermSelectItem[] = [];

  for (const perm of data.data.perms) {
    const temp = {
      value: perm.perm,
      label: perm.name,
      description: perm.description,
    };
    if (perm.cat === "Yacht Admin") {
      adminPerms.push(temp);
    } else if (perm.cat === "Yacht Users") {
      userPerms.push(temp);
    }
  }

  const logbooks: LogbookSelectItem[] = [];

  for (const log of data.data.logbooks) {
    if (log.lbname && log.lbid) {
      logbooks.push({
        value: log.lbid,
        label: log.lbname,
        parts: log.parts
          ? log.parts.map((part: any) => ({
              value: part.lbid,
              label: part.lbname,
            }))
          : null,
      });
    }
  }

  return {
    selects: {
      types: data.data.types.map((type: { id: string; name: string }) => ({
        value: type.id,
        label: type.name,
      })),
      roles: data.data.roles.map(
        (role: { crid: string; rolename: string }) => ({
          value: role.crid,
          label: role.rolename,
        }),
      ),
      logbooks,
      adminPerms,
      userPerms,
    },
    initialValues,
  };
};

export const mapUserSelects = (data: any) => {
  const adminPerms: PermSelectItem[] = [];
  const userPerms: PermSelectItem[] = [];

  for (const perm of data.data.perms) {
    const temp = {
      value: perm.perm,
      label: perm.name,
      description: perm.description,
    };
    if (perm.cat === "Yacht Admin") {
      adminPerms.push(temp);
    } else if (perm.cat === "Yacht Users") {
      userPerms.push(temp);
    }
  }
  const roles = data.data.roles.map(
    (role: { crid: string; rolename: string }) => ({
      value: role.crid,
      label: role.rolename,
    }),
  ) as SelectItem[];

  return { adminPerms, userPerms, roles };
};
